import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    AppconfigState,
    FontSizeType,
    InsperaObject,
    MicObject,
    SpeedObject,
    PageObject,
    SpeakCheckScreenDetailsObject,
    CalibrationDetails,
} from '../interface/interface';

const initialState: AppconfigState = {
    testTaker: {
        testTakerId: '1234567890',
        testTakerName: 'Test Taker 1',
        testTakerUsername: 'TestTaker_Username',
        testTakerCenterName: 'London',
        testTakerLanguage: 'en_GB',
        testTakerAccessToken: '',
        testTakerSessionId: '',
    },
    appTheme: 'black_on_white',
    appFontSize: 'sm',
    appAudioLevel: 100,
    appMicAccess: false,
    selectedMic: {
        deviceId: '',
        label: '',
    },
    silenceMeanValue: 0,
    insperaDetails: {
        assessmentId: '',
        externalId: '',
        partner: '',
        product: '',
    },
    fileSpeed: {
        uploadSpeed: '',
        downloadSpeed: '',
    },
    speakCheckScreenDetails: {
        duration: 0,
        responseFilePath: '',
    },
    pageObject: {
        pageIndex: 0,
        isSpeakCheckDone: false,
        disableSummaryScreenButton: false,
    },
    soundCheckScreenAudio: false,
    isSilent: false,
    precheckApiError:'',
    calibrationDetails: {
        status: 'LIVE',
        level: ''
    }
};

export const appConfigSlice = createSlice({
    name: 'appConfigSlice',
    initialState,
    reducers: {
        resetStore: () => {
            return initialState;
        },
        changeTestTaker: (state, action: PayloadAction<any>) => {
            state.testTaker = { ...state.testTaker, ...action.payload };
        },
        changeAppFontSize: (state, action: PayloadAction<FontSizeType>) => {
            state.appFontSize = action.payload;
        },
        changeAppTheme: (state, action: PayloadAction<string>) => {
            state.appTheme = action.payload;
        },
        changeAppAudioLevel: (state, action: PayloadAction<number>) => {
            state.appAudioLevel = action.payload;
        },
        changeAppMicAccess: (state, action: PayloadAction<boolean>) => {
            state.appMicAccess = action.payload;
        },
        changeSelectedMic: (state, action: PayloadAction<MicObject>) => {
            state.selectedMic = action.payload;
        },
        changeSilenceValue: (state, action: PayloadAction<any>) => {
            state.silenceMeanValue = action.payload;
        },
        changeAccessTokenValue: (state, action: PayloadAction<any>) => {
            state.testTaker.testTakerAccessToken = action.payload;
        },
        changeTestTakerUsernameValue: (state, action: PayloadAction<any>) => {
            state.testTaker.testTakerUsername = action.payload;
        },
        changeTestTakerSessionIdValue: (state, action: PayloadAction<any>) => {
            state.testTaker.testTakerSessionId = action.payload;
        },
        changeInsperaDetails: (state, action: PayloadAction<InsperaObject>) => {
            state.insperaDetails = action.payload;
        },
        changePageDetails: (state, action: PayloadAction<PageObject>) => {
            state.pageObject = action.payload;
        },
        changeFileSpeed: (state, action: PayloadAction<SpeedObject>) => {
            state.fileSpeed = action.payload;
        },
        changeSpeakPrecheckDuration: (state, action: PayloadAction<SpeakCheckScreenDetailsObject>) => {
            state.speakCheckScreenDetails = action.payload;
        },
        changeSoundScreenAudio: (state, action: PayloadAction<boolean>) => {
            state.soundCheckScreenAudio = action.payload;
        },
        changeIsSilent: (state, action: PayloadAction<boolean>) => {
            state.isSilent = action.payload;
        },
        changePrecheckApiError: (state, action: PayloadAction<string>) => {
            state.precheckApiError = action.payload;
        },
        changeCalibrationDetails: (state, action: PayloadAction<CalibrationDetails>) => {
            state.calibrationDetails = action.payload;
        }
    },
});

export const {
    resetStore,
    changeAppFontSize,
    changeAppTheme,
    changeAppAudioLevel,
    changeAppMicAccess,
    changeSelectedMic,
    changeSilenceValue,
    changeTestTaker,
    changeAccessTokenValue,
    changeTestTakerUsernameValue,
    changeTestTakerSessionIdValue,
    changeInsperaDetails,
    changePageDetails,
    changeFileSpeed,
    changeSpeakPrecheckDuration,
    changeSoundScreenAudio,
    changeIsSilent,
    changePrecheckApiError,
    changeCalibrationDetails
} = appConfigSlice.actions;

export default appConfigSlice.reducer;
